import React, { useState } from "react";
import moment from "moment";
import { Row, Col, Typography, Modal, TimePicker, Select } from "antd";
import "./index.css";
import { ROOM_LIST } from "../../../../configurableConst";

const { Title } = Typography;
const format = "HH:mm";
const timeFormat = "HH:mm";

const TimeslotModal = ({ timeslots, setTimeslots, isTimeModalOpen, toggleModal, resetStatus }) => {
  const [startTime, setStartTime] = useState(moment("09:00", timeFormat).format(timeFormat));
  const [endTime, setEndTime] = useState(moment("09:30", timeFormat).format(timeFormat));
  const [selectedRoom, setSelectedRoom] = useState();
  const [timeslotsError, setTimeslotsError] = useState(null);

  const validateTimeslot = () => {
    const momentStartTime = moment(startTime, timeFormat);
    const momentEndTime = moment(endTime, timeFormat);
    const isBefore = momentStartTime.isBefore(momentEndTime);

    if (!selectedRoom) {
      return "Room is required";
    }

    if (!isBefore) {
      return "The start time must precede the end time";
    }

    return timeslots.reduce((error, { start: existedStartTime, end: existedEndTime }) => {
      const momentExistedStartTime = moment(existedStartTime, timeFormat);
      const momentExistedEndTime = moment(existedEndTime, timeFormat);
      const isNotOverlapping =
        momentEndTime.isBefore(momentExistedStartTime) || momentExistedEndTime.isBefore(momentStartTime);
      if (!isNotOverlapping) {
        return "Time slots cannot overlap";
      }

      return error;
    }, null);
  };

  const createTimeslots = () => {
    const error = validateTimeslot();
    if (!error) {
      setTimeslotsError(null);
      setTimeslots([
        ...timeslots,
        {
          id: `${startTime}-${endTime}`,
          start: startTime,
          end: endTime,
          selectedRoom,
        },
      ]);
      toggleModal(false);
      return;
    }

    setTimeslotsError(error);
  };

  return (
    <Modal
      width={800}
      title="Please pick a time"
      visible={isTimeModalOpen}
      onOk={createTimeslots}
      onCancel={() => toggleModal(false)}
    >
      <Row gutter={6}>
        <Col span={8}>
          <Title level={5}>Start time</Title>
          <TimePicker
            inputReadOnly
            minuteStep={5}
            className={timeslotsError ? "has-error" : ""}
            format={format}
            value={moment(startTime, timeFormat)}
            onSelect={(time) => {
              resetStatus();
              setTimeslotsError(null);
              setStartTime(moment(time).format(timeFormat));
            }}
          />
        </Col>
        <Col span={8}>
          <Title level={5}>End time</Title>
          <TimePicker
            inputReadOnly
            minuteStep={5}
            className={timeslotsError ? "has-error" : ""}
            value={moment(endTime, timeFormat)}
            format={format}
            onSelect={(time) => {
              resetStatus();
              setTimeslotsError(null);
              setEndTime(moment(time).format(timeFormat));
            }}
          />
        </Col>
        <Col span={8}>
          <Title level={5}>Room</Title>
          <Select style={{ width: "80%" }} onChange={setSelectedRoom} value={selectedRoom}>
            {ROOM_LIST[process.env.REACT_APP_HOSPITAL_NAME].map(({ key, label }) => (
              <Select.Option key={key} value={key}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
      {timeslotsError && <div className="timeslots-error">{timeslotsError}</div>}
    </Modal>
  );
};

export default TimeslotModal;
